export function tracePropagationPatterns(
  explicit: string | undefined,
  getBackendUrl: () => string | undefined
): RegExp[] {
  const additionalOrigins = new Set(
    (explicit ?? '')
      .split(',')
      .map((url) => httpOrigin(url.trim()))
      .filter((origin) => origin !== undefined)
  );

  return [new BackendOriginMatcher(getBackendUrl, additionalOrigins)];
}

// Faro accepts only strings/RegExp; OpenTelemetry uses String.match today.
// Overriding exec supports both match and test while reading the API client's
// current URL, including initialization after Faro and later backend switches.
class BackendOriginMatcher extends RegExp {
  constructor(
    private readonly getBackendUrl: () => string | undefined,
    private readonly additionalOrigins: Set<string>
  ) {
    super('^');
  }

  override exec(url: string): RegExpExecArray | null {
    const origin = httpOrigin(url, window.location.href);
    const backendOrigin = httpOrigin(this.getBackendUrl(), window.location.href);

    return origin !== undefined && (origin === backendOrigin || this.additionalOrigins.has(origin))
      ? super.exec(url)
      : null;
  }
}

function httpOrigin(url: string | undefined, baseUrl?: string): string | undefined {
  if (!url) {
    return undefined;
  }
  try {
    const parsed = new URL(url, baseUrl);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:' ? parsed.origin : undefined;
  } catch {
    // Invalid tracing targets must not interrupt a request or broaden propagation.
    return undefined;
  }
}
